export default {
    setResponse(state, data) {
        state.data = data;
    }
}